module.exports = __webpack_public_path__ + "static/media/ic_hearing_set.8fbf4bce.svg";